import React, {
  Component, useState, useEffect, useRef
} from 'react';
import {
  Spin, Row, Col, Divider, Badge, Button, Radio, Form, Icon, Layout, Menu, Modal, Checkbox, Table, Tag, Tabs, Tooltip, Select, Input, Space, Drawer, Switch, Typography, Card, message, DatePicker
} from 'antd';
import {
  EyeOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import 'antd/dist/antd.css';
import moment from 'moment';
import Fuse from 'fuse.js';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import * as Service from '../../core/Service';
import * as Main from '../../core/Main';
import NavAndSideFrame from '../../components/NavAndSideFrame';
import CommonAreaFormModal from '../../components/CommonAreaFormModal';

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
// const title = "Order List";
const selectedKey = 'common_area_list';
const openKey = 'order';
const filterableFields = [
  `order_key`,
  `user_id`,
  `nickname`,
  `email`,
  `date_completed`,
  `currency`,
  `original_price`,
  `final_price`,
  `discount`,
  `token_used`,
  `token_earned`,
  `remarks`,
  `mobile`
  // `ptx_key`,

];

const CommonAreaList = (props) => {
  const { t } = useTranslation();
  const title = t("common_area_list");
  const now = moment().unix();
  const momentNow = moment();

  const [dataList, setDataList] = useState([]);
  const [filterDataList, setFilterDataList] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [isChangingIsActive, setChangingIsActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [minDate, setMinDate] = useState(0);
  const [maxDate, setMaxDate] = useState(now);
  const [minStartTime, setMinStartTime] = useState(0);
  const [maxStartTime, setMaxStartTime] = useState(now);
  const [minEndTime, setMinEndTime] = useState(0);
  const [maxEndTime, setMaxEndTime] = useState(now);

  const tableIDName = "order_table";

  useEffect(() => {
    // setLoading(true);
    getAllData();
  }, [modalVisible]);

  useEffect(() => {
    filterData();
  }, [
    searchKeyword,
    minDate,
    maxDate,
    minStartTime,
    maxStartTime,
    minEndTime,
    maxEndTime
  ]);

  const filterData = () => {
    debounce(() => {
      let searchedList = dataList;
      if (_.isEmpty(dataList)) return;
      console.log('unChangeData', dataList);
      if (!_.isEmpty(searchKeyword)) {
        searchedList = getDataBySearchKeyword(searchKeyword);
        console.log(`searchedList >> keyword ${searchKeyword} >> `, searchedList)
      }

      if (minDate !== 0) {
        searchedList = _.compact(searchedList);
        searchedList = _.map(searchedList, (rowData) => {
          if (_.isUndefined(rowData)) return;
          if (rowData.booking_date > minDate) return rowData;
        });
        console.log(`searchedList >> minDate ${minDate} >> `, searchedList)
      }

      if (maxDate !== now) {
        searchedList = _.compact(searchedList);
        searchedList = _.map(searchedList, (rowData) => {
          if (_.isUndefined(rowData)) return;
          if (rowData.booking_date < maxDate) return rowData;
        });
        console.log(`searchedList >> maxDate ${maxDate} >> `, searchedList)
      }

      searchedList = _.compact(searchedList);
      setFilterDataList(searchedList);
    }, 400);
  }


  const getAllData = async () => {
    let result = await Service.call('GET', '/api/order/common_area/list');
    console.log('result >>>>>>', result);
    // if (result.status !== 1) {
    //   return message.error(result.errorMessage);
    // }
    setDataList(result);
    setFilterDataList(result);
  }

  const setTableHeader = () => {
    let columns = [
      {
        title: t('operation'),
        dataIndex: tableIDName,
        render: (value, record, key) => {
          return (
            <span>
              <Tooltip title={t('edit')}>
                <Button
                  shape="circle"
                  style={{ marginRight: 4 }}
                  icon={<EyeOutlined />}
                  // disabled={record.is_active ? true : false}
                  onClick={() => {
                    setSelectedRecord(record)
                    setModalVisible(true);
                  }}
                />
              </Tooltip>
              {/* <Tooltip title={record.is_active ? t('deactivate') : t('activate')}>
                <Button
                  shape="circle"
                  style={{ marginRight: 4}}
                  icon={record.is_active ? <CloseCircleOutlined /> : <CheckCircleOutlined />}
                  onClick={async () => {
                    if (isChangingIsActive) return;
                    setChangingIsActive(true);
                    let is_active = record.is_active ? 0 : 1
                    await Service.call('PATCH', '/api/item/holiday/status',
                      {
                        item_holiday_id: record.item_holiday_id,
                        is_active
                      });
                    // getAllData();
                    setChangingIsActive(false);
                  }}
                />
              </Tooltip> */}
            </span>
          )
        }
      },
      // {
      //   title: t('order_key'),
      //   dataIndex: 'order_key',
      //   // sorter: (a, b) => a.order_key.localeCompare(b.order_key)
      // },
      // {
      //   title: t('active_status'),
      //   dataIndex: 'is_active',
      //   render: (value) => displayIsActive(value),
      //   sorter: (a, b) => a.is_active - b.is_active
      // },
      // {
      //   title: t('status'),
      //   dataIndex: 'status',
      //   render: (value) => displayStatus(value),
      //   sorter: (a, b) => a.status.localeCompare(b.status)
      // },
      {
        title: t('name'),
        dataIndex: 'name',
        sorter: (a, b) => a.name.localeCompare(b.name)
      },
      {
        title: t('email'),
        dataIndex: 'email',
        sorter: (a, b) => a.email.localeCompare(b.email)
      },
      {
        title: t('mobile'),
        dataIndex: 'mobile',
      },
      {
        title: t('remarks'),
        dataIndex: 'remarks',
      },
      {
        title: t('date'),
        dataIndex: 'booking_date',
        render: (value) => moment.unix(value).format('YYYY/MM/DD'),
        sorter: (a, b) => a.booking_date - b.booking_date
      },
      {
        title: t('start_time'),
        dataIndex: 'start_time',
        render: (value) => moment.unix(value).format('HH:mm'),
        sorter: (a, b) => moment.unix(a.start_time).format('HH:mm').localeCompare(moment.unix(b.start_time).format('HH:mm')),
      },
      {
        title: t('end_time'),
        dataIndex: 'end_time',
        render: (value) => moment.unix(value).format('HH:mm'),
        sorter: (a, b) => moment.unix(a.end_time).format('HH:mm').localeCompare(moment.unix(b.end_time).format('HH:mm')),
      },
      {
        title: t('room'),
        dataIndex: 'item_name',
        sorter: (a, b) => a.item_name.localeCompare(b.item_name),
      },
      {
        title: t('ctime'),
        dataIndex: 'ctime',
        render: (value) => moment.unix(value).format('YYYY/MM/DD HH:mm:ss'),
        sorter: (a, b) => a.ctime - b.ctime,
        defaultSortOrder: 'descend',
      },
      // {
      //   title: t('date_completed'),
      //   dataIndex: 'date_completed',
      //   sorter: (a, b) => a.date_completed - b.date_completed,
      //   render: (value) => displayMoment(value),
      // },
      // {
      //   title: t('currency'),
      //   dataIndex: 'currency',
      //   sorter: (a, b) => a.currency - b.currency
      // },
      // {
      //   title: t('original_price'),
      //   dataIndex: 'original_price',
      //   sorter: (a, b) => a.original_price - b.original_price,
      //   render: (value) => displayCurrency(value),
      // },
      // {
      //   title: t('discount'),
      //   dataIndex: 'discount',
      //   sorter: (a, b) => a.discount - b.discount,
      //   render: (value) => displayCurrency(value),
      // },
      // {
      //   title: t('token_used'),
      //   dataIndex: 'token_used',
      //   sorter: (a, b) => a.token_used - b.token_used
      // },
      // {
      //   title: t('final_price'),
      //   dataIndex: 'final_price',
      //   sorter: (a, b) => a.final_price - b.final_price,
      //   render: (value) => displayCurrency(value),
      // },
      // {
      //   title: t('token_earned'),
      //   dataIndex: 'token_earned',
      //   sorter: (a, b) => a.token_earned - b.token_earned
      // },
      // {
      //   title: t('ptx_key'),
      //   dataIndex: 'ptx_key',
      //   sorter: (a, b) => a.ptx_key - b.ptx_key
      // },
    ]

    return columns;
  };

  const displayStatus = (value) => {
    let status = _.toString(value);
    let wording = ``;
    switch (status) {
      case "placed": wording = t("placed"); break;
      case "paid": wording = t("paid"); break;
      case "payment_confirmed": wording = t("payment_confirmed"); break;
      case "payment_failed": wording = t("payment_failed"); break;
      case "payment_refund": wording = t("payment_refund"); break;
      case "in_delivery": wording = t("in_delivery"); break;
      case "cancelled": wording = t("cancelled"); break;
      case "expired": wording = t("expired"); break;
      default: wording = t('error');
    }
    return wording;
  }

  const displayCurrency = (value) => {
    let amount = Intl.NumberFormat().format(value);
    return "$" + amount
  }

  const displayMoment = (unixTime, outputFormat = 'YYYY/MM/DD HH:mm') => {
    let displayTime = '';
    if (unixTime !== 0) {
      displayTime = moment.unix(unixTime).format(outputFormat);
    } else {
      displayTime = '-'
    }
    return displayTime;
  }

  const displayIsActive = (value) => {
    let displayStr = '';
    let tagColor = 'green';
    let statusValue = _.toInteger(value);
    switch (statusValue) {
      case 1:
        displayStr = t("active");
        tagColor = 'green';
        break;
      case 0:
        displayStr = t("inactive");
        tagColor = 'red';
        break;
      default:
        displayStr = t("error")
        tagColor = '#f50';
        break;
    }
    return <Tag color={tagColor}>{displayStr}</Tag>;
  }

  const getDataBySearchKeyword = (keywords) => {
    let searchedList = [];
    try {
      const options = {
        includeScore: true,
        findAllMatches: true,
        threshold: 0, // exact match
        keys: filterableFields,
        ignoreLocation: true, // also search within strings not only from start
      };
      const fuse = new Fuse(dataList, options);
      const result = fuse.search(keywords);
      searchedList = _.map(result, "item");
      searchedList = _.orderBy(searchedList, ["user_id"], ["desc"]);
      return searchedList
    } catch (error) {
      console.error("error >>> ", error);
    } finally {
      // setDataList(dataList);
    }
  };

  const onDateChange = (moments) => {
    let start_date
    let end_date;
    console.log(moments);
    if (!_.isNull(moments)) {
      start_date = moments[0].unix();
      end_date = moments[1].unix();
    }
    if (_.isUndefined(start_date)) start_date = 0
    if (_.isUndefined(end_date)) end_date = now;

    console.log('start end', start_date, end_date)
    setMinDate(start_date);
    setMaxDate(end_date);
  };

  const onStartDateChange = (moments) => {
    let start_date
    let end_date;
    console.log(moments);
    if (!_.isNull(moments)) {
      start_date = moments[0].unix();
      end_date = moments[1].unix();
    }
    if (_.isUndefined(start_date)) start_date = 0
    if (_.isUndefined(end_date)) end_date = now;

    console.log('start end', start_date, end_date)
    setMinStartTime(start_date);
    setMaxStartTime(end_date);
  };

  const onEndDateChange = (moments) => {
    let start_date
    let end_date;
    console.log(moments);
    if (!_.isNull(moments)) {
      start_date = moments[0].unix();
      end_date = moments[1].unix();
    }
    if (_.isUndefined(start_date)) start_date = 0
    if (_.isUndefined(end_date)) end_date = now;

    console.log('start end', start_date, end_date)
    setMinEndTime(start_date);
    setMaxEndTime(end_date);
  };

  let timeout;
  const debounce = (func, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(func, delay);
  };

  const onChange = (keyword) => {
    setSearchKeyword(keyword);
  };

  const onExportTable = () => {
    const processedDataList = _.map(filterDataList, (data) => {
      return {
        ...data,
        booking_date: data.booking_date === 0 ? '-' : moment(data.booking_date, 'X').format('YYYY-MM-DD HH:mm:ss'),
        start_time: data.start_time === 0 ? '-' : moment(data.start_time, 'X').format('YYYY-MM-DD HH:mm:ss'),
        end_time: data.end_time === 0 ? '-' : moment(data.end_time, 'X').format('YYYY-MM-DD HH:mm:ss'),
      }
    });

    Main.exportTableToCSV(processedDataList, 'export');
  };

  return (
    <NavAndSideFrame {...props} title={title} selectedKey={selectedKey} openKey={openKey} onExportTable={onExportTable}>
      <Row>
        <Col style={{ marginTop: 5, marginLeft: 10 }}>
          {t(`search`) + `:`}
        </Col>
        <Col style={{ marginLeft: 20 }}>
          <Input
            placeholder={t(`please_input_keyword`)}
            style={{ minWidth: 270, width: '50%' }}
            onChange={
              (values) => {
                onChange(values.target.value);
              }
            }
          />
        </Col>
        <Col style={{ marginTop: 5, marginLeft: 10 }}>
          {t(`date`) + `:`}
        </Col>
        <Col style={{marginLeft: 20}}>
          <RangePicker
            // defaultValue={[moment().subtract(1, 'month'), momentNow]}
            style={{ minWidth: 270, width: '50%' }}
            onChange={onDateChange}
          />
        </Col>
      </Row>
      <Row>
        <Col style={{ marginTop: 5, marginLeft: 10 }}>
          {t(`start_time`) + `:`}
        </Col>
        <Col style={{marginLeft: 20}}>
          <RangePicker
            showTime
            style={{ minWidth: 270, width: '50%' }}
            onChange={onStartDateChange}
          />
        </Col>
        <Col style={{ marginTop: 5, marginLeft: 10 }}>
          {t(`end_time`) + `:`}
        </Col>
        <Col style={{marginLeft: 20}}>
          <RangePicker
            showTime
            style={{ minWidth: 270, width: '50%' }}
            onChange={onEndDateChange}
          />
        </Col>
      </Row>
      <Divider />
      <Spin spinning={loading}>
        <Table
          bordered
          size="small"
          pagination={{
            defaultPageSize: 25,
            showSizeChanger: true,
            pageSizeOptions: [25, 50, 100, 200, 500]
          }}
          rowKey={tableIDName}
          scroll={{ x: 'max-content' }}
          dataSource={filterDataList}
          columns={setTableHeader()}
        />
        <CommonAreaFormModal
          modalVisible={modalVisible}
          selectedOrder={selectedRecord}
          setModalVisible={setModalVisible}
        />
      </Spin>
    </NavAndSideFrame>
  )
}

export default CommonAreaList;
